<app-group-header [Heading]="'Positionierung' | translate"
                  [chart]="chart"
                  [info]="info"
                  (chartEvent)="getChartEvent($event)"
                  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'X-Position' | translate"
                      [Error]="XPosition?.isError"
                      [ErrorLevel]="XPosition?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[XPosition?.TimeseriesData]"
                      [Legend]="['X-Position' | translate]"
                      [Info]="'Motor X Position'"
                      [resizeEvent]="childResizeEvent">
    </app-default-card>

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Y-Position' | translate"
                      [Error]="YPosition?.isError"
                      [ErrorLevel]="YPosition?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[YPosition?.TimeseriesData]"
                      [Legend]="['Y-Position' | translate]"
                      [Info]="'Motor Y Position'"
                      [resizeEvent]="childResizeEvent">
    </app-default-card>

    <app-default-card *ngIf="Aisle != null" class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Gasse' | translate"
                      [Error]="Aisle?.isError"
                      [ErrorLevel]="Aisle?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Aisle?.TimeseriesData]"
                      [Legend]="['Gasse' | translate]"
                      [Info]="'Gasse in der sich das Geräte befindet'"
                      [resizeEvent]="childResizeEvent">
    </app-default-card>

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Letzte Motorposition' | translate"
                      [Error]="LastEnginePosition?.isError"
                      [ErrorLevel]="LastEnginePosition?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[LastEnginePosition?.TimeseriesData]"
                      [Unit]="'mm'"
                      [Legend]="['Letzte Motorposition' | translate]"
                      [resizeEvent]="childResizeEvent">
    </app-default-card>

</div>
